// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"a4de34ddffa0fcbb6283","339":"f2961f3f2231ad22a65b"}[chunkId] + ".js";
};